import { Injectable } from '@angular/core';
import { OccConfig } from '@spartacus/core';
import { TextAndImage } from './text-and-image';
import { ToolsService } from '../../../../../../../core/services/tools.service';
import { ColorPipe } from '../../../theme/core/assets/color.pipe';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class TextAndImageService {
  constructor(
    private occConfig: OccConfig,
    private toolsService: ToolsService,
    private colorPipe: ColorPipe,
    private sanitizer: DomSanitizer,
  ) {}

  getNumbers(value: string): string {
    return value.replace(/\D/g, '');
  }

  normalize(data: any): TextAndImage {
    const textAndImage: TextAndImage = {
      htmlText: this.sanitizer.bypassSecurityTrustHtml(data.content || ``),
      config: {
        isInverted: this.toolsService.stringToBoolean(data.imgInverted),
        imagePercentWidth: this.getNumbers(data.imageWidth || `50`) + `%`,
        textBgColor: this.colorPipe.transform(data.bgColor || ``),
      },
    };

    if (data?.action?.linkName && data?.action?.url) {
      textAndImage.action = {
        label: data?.action?.linkName,
        url: data?.action?.url,
        isExternal: data?.action?.target === `true`,
      };
    }

    if (data?.image?.url) {
      textAndImage.image = {
        src: this.occConfig.backend?.occ?.baseUrl + data?.image?.url,
      };
    }

    return textAndImage;
  }
}
